import { useEffect, useState } from "react";
import {
  MdAutoAwesome,
  MdCheckCircle,
  MdHandshake,
  MdLocationOn,
  MdOutlineTrendingUp,
  MdShield,
  MdVerified,
} from "react-icons/md";
import { getInlineLoader } from "../Helpers";
import boxImage from "../assets/award.png";
import logo from "../assets/small-logo.png";

const values = [
  {
    title: "Integrity",
    text: "We operate with honesty and transparency.",
    icon: <MdShield size={24} />,
  },
  {
    title: "Customer Focus",
    text: "Our customers are at the heart of everything we do.",
    icon: <MdHandshake size={24} />,
  },
  {
    title: "Quality",
    text: "We are committed to offering only the best.",
    icon: <MdVerified size={24} />,
  },
  {
    title: "Reliability",
    text: "We deliver on our promises with consistency.",
    icon: <MdCheckCircle size={24} />,
  },
  {
    title: "Growth",
    text: "We continuously improve and evolve.",
    icon: <MdOutlineTrendingUp size={24} />,
  },
  {
    title: "Creativity",
    text: "We shape customer stories into products people can see and remember.",
    icon: <MdAutoAwesome size={24} />,
  },
];

export default function AboutUsContent({ showHeader = true }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }

  return (
    <section className="MainBodySection about-page-section">
      <div className="container">
        {showHeader ? (
          <div className="about-page-section-heading text-center">
            <p className="home-banner-kicker">About Esmeriser</p>
            <h2 className="home-service-title font-bold">Who We Are</h2>
          </div>
        ) : null}

        <div className="about-page-story">
          <div className="about-page-story-copy" data-aos="fade-right">
            <p className="home-banner-kicker">Our Story</p>
            <h2 className="font-bold">A Trusted Name for Quality and Convenience.</h2>
            <p>
              Esmeriser Investment is a dynamic business dedicated to providing
              quality products and reliable services that meet everyday customer
              needs. The company focuses on delivering value, trust, and
              convenience to clients both online and offline.
            </p>
            <p>
              With a strong commitment to customer satisfaction, Esmeriser
              continues to grow as a trusted name, offering carefully selected
              products and building lasting relationships with its customers.
            </p>

            <div className="about-page-location">
              <MdLocationOn size={24} />
              <span>Mbuyuni, near Namanga, Manara Street, Gate No. 32</span>
            </div>
          </div>

          <div className="about-page-story-card" data-aos="fade-left">
            <img src={logo} alt="Esmeriser" className="about-page-story-logo" />
            <img
              src={boxImage}
              alt="Esmeriser branded packaging"
              className="about-page-story-img"
            />
          </div>
        </div>

        <div className="about-page-purpose">
          <article className="about-page-purpose-card" data-aos="fade-up">
            <span className="about-page-purpose-label">Mission</span>
            <h3 className="font-bold">Creative Output for Dream Products.</h3>
            <p>
              To deliver high-quality products based on each customer story,
              using creativity to shape output that meets their dream product,
              while ensuring exceptional customer experience through trust,
              efficiency, and consistency.
            </p>
          </article>

          <article className="about-page-purpose-card" data-aos="fade-up">
            <span className="about-page-purpose-label">Vision</span>
            <h3 className="font-bold">A Leading Trusted Brand in Tanzania.</h3>
            <p>
              To be a leading and trusted brand in Tanzania, recognized for
              excellence, creativity, innovation, and strong customer
              relationships, both locally and beyond.
            </p>
          </article>
        </div>

        <div className="about-page-values">
          <div className="about-page-values-head" data-aos="fade-up">
            <p className="home-banner-kicker">Core Values</p>
            <h2 className="home-service-title font-bold">What Guides Us</h2>
          </div>

          <div className="about-page-values-grid">
            {values.map((value) => (
              <article className="about-page-value-card" key={value.title}>
                <span className="about-page-value-icon">{value.icon}</span>
                <h3 className="font-bold">{value.title}</h3>
                <p>{value.text}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
